<div class="grid-x grid-margin-x section">
  <form [formGroup]="form">
    @if (hasFieldNotes('apiNumber')) {
      <div>
        <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      </div>
    }
    <well-selector [organization]="organization" [enableSelections]="enableWellSelection" [reportType]="reportType" (throw)="handleError($event)" (selectedWells)="onWellsSelected($event)"></well-selector>

    <ng-container class="cell small-12 medium-12 large-12">
      @if (hasFieldNotes('confidentiality')) {
        <span> <view-notes [fieldName]="'confidentiality'" [notes]="getFilteredNotes('confidentiality')" (notesRequested)="handleNotesRequested($event)"></view-notes></span>
      }

      <div class="checkbox">
        <input class="show-for-sr" id="confidentiality" type="checkbox" formControlName="confidentiality" (change)="onConfidentialityChecked($event)" />
        <label for="confidentiality">
          Confidentiality - ORC 1509.10 allows the option for an owner to retain logs for up to six months. It is the owner's responsibility to submit such logs upon their due date:
          <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
        </label>
      </div>
    </ng-container>

    @if (!filesUploaded) {
      @if (hasFieldNotes('logsRunCheck')) {
        <span> <view-notes [fieldName]="'logsRunCheck'" [notes]="getFilteredNotes('logsRunCheck')" (notesRequested)="handleNotesRequested($event)"></view-notes></span>
      }
      <div class="checkbox">
        <input class="show-for-sr" id="logsRunCheck" type="checkbox" formControlName="logsRunCheck" (change)="onNoLogsChecked($event)" />
        <label for="logsRunCheck" class="bold">
          No logs were run:
          <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
        </label>
      </div>
    }

    @if (!noLogsChecked) {
      <div>
        <div>
          @if (hasFieldNotes('typeOfLog') || isInReview) {
            <span>
              <view-notes [fieldName]="'typeOfLog'" [notes]="getFilteredNotes('typeOfLog')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            </span>
          }
          <label for="typeOfLog">
            Type of Log Run
          </label>
          <input type="text" formControlName="typeOfLog" />
        </div>
        <div>
          @if (hasFieldNotes('loggingCompany') || isInReview) {
            <span>
              <view-notes [fieldName]="'loggingCompany'" [notes]="getFilteredNotes('loggingCompany')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            </span>
          }
          <label for="loggingCompany">
            Name of Logging Company
          </label>
          <input type="text" formControlName="loggingCompany" />
        </div>
      </div>
    }

    @if (!noLogsChecked) {
      <div class="grid-x grid-margin-x padding-bottom-large section">
        <div class="cell small-12 medium-12 large-12 bold">
          Upload Logs. Anything uploaded and submitted is a public record.: <span class="bold">*</span>
        </div>
        <div class="cell small-12 medium-12 large-12">
          @if (hasFieldNotes('uploadedFiles')) {
            <span> <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes></span>
          }
          <upload-view-files [uniqueId]="'uploader'" [files]="uploadedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="uploadedFilesCtrl?.enabled" [allowUpload]="uploadedFilesCtrl?.enabled" (fileRemoved)="onFileDeleted($event)" (newFilesList)="fileAdded($event)">
          </upload-view-files>
        </div>
        @if (isInternal) {
          <div class="cell">
            <label for="receivedDate">Date Log was Received</label>
            <common-date-picker [id]="'receivedDate'" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate"></common-date-picker>
          </div>
        }
      </div>
    }
    @if (!isInReview&& wellIsSelected) {
      <div class="grid-x grid-margin-x">
        @switch (true) {
          @case (!isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              <p>By clicking submit, I certify that the information provided is true and accurate, to the best of my knowledge.</p>
              <span class="minor-margin-right">
                <button class="button" (click)="saveForLater()">Save for Later</button>
              </span>
              <ng-container>
                <span class="minor-margin-right">
                  <button class="button" [disabled]="!filesUploaded && !noLogsChecked" (click)="submit()">Submit</button>
                </span>
              </ng-container>
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
          @case (isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" (click)="saveForLater()">Save for Later</button>
                </span>
              }
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" [disabled]="!filesUploaded && !noLogsChecked" (click)="onAccept()">Accept</button>
                </span>
              }
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
        }
      </div>
    }

  </form>
</div>
<hr />